import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as styles from "./ApprovalDetails.css";
import { Store } from '../../stores';
import { LocalizationService } from '../../../../services/LocalizationService';
import { Environment } from '../../../../services/Environment';
import { IAPersonaSmall } from '../../../personaSmall/PersonaSmall';
import { Helper } from '../../../../Helper';
import { IAIcon } from '../../../icon/Icon';
import { IALikesAndComments } from '../../../likesAndComments/LikesAndComments';

export interface IApprovalDetailsProps {
  store?: Store;
  onChange(): void;
}

@inject('store')
@observer
export default class ApprovalDetails extends React.Component<IApprovalDetailsProps> {

  private localizationService: LocalizationService = new LocalizationService();

  constructor(props: IApprovalDetailsProps) {
    super(props);
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    return (
      <div className={styles.approvalDetails}>
        <div className={styles.approversContainer} style={this.props.store.creatingNewMessage ? { marginBottom: "0px" } : {}}>
          <label className={styles.label}>{this.localizationService.strings.Messages_EditPanel_Approvers} <span style={{ color: "red" }}>*</span></label>
          {this.props.store.approvers &&
            this.props.store.approvers.map((approver, index) => (
              <div
                className={styles.approverPersonContainer}
                key={approver.userPrincipalName}
              >
                <IAPersonaSmall
                  name={approver.name}
                  profileImage={Helper.getProfileImageUrlFromImageAPI(Environment.getEnvironmentForImageAPI(this.props.store.environment),
                    this.props.store.tenant, this.props.store.token, approver.userPrincipalName)}
                  styles={approver.disabled ?
                    { width: "auto", marginRight: "10px", marginTop: "0px", transition: "opacity 200ms", opacity: "0.5" }
                    :
                    { width: "auto", marginRight: "10px", marginTop: "0px", transition: "opacity 200ms" }
                  }
                  highlightColor={this.props.store.highlightColor}
                />
                <div
                  className={styles.removePerson}
                  onClick={() => {
                    this.props.store.approvers[index].disabled = !approver.disabled;
                    this.forceUpdate();
                    this.props.onChange();
                  }}
                >
                  <IAIcon
                    title="Add"
                    size={18}
                    color="#333333"
                    style={approver.disabled ?
                      {
                        marginTop: 2,
                        marginLeft: 0,
                        transition: "transform 200ms"
                      }
                      :
                      {
                        transform: "rotate(45deg)",
                        marginTop: 2,
                        marginLeft: -2,
                        transition: "transform 200ms"
                      }
                    }
                  />
                </div>
              </div>
            ))
          }
        </div>
        {!!this.props.store.id &&
          <div>
            <label className={styles.label}>{this.localizationService.strings.Messages_EditPanel_ApprovalComments}</label>
            <IALikesAndComments
              itemId={this.props.store.id.toString()}
              tenant={this.props.store.tenant}
              component={`${this.props.store.component}-approval`}
              instance={this.props.store.instance}
              token={this.props.store.token}
              environment={this.props.store.environment}
              user={this.props.store.user}
              imageUploadUrl={`${Helper.getMainAPIUrl(this.props.store.environment)}/api/${this.props.store.tenant}.sharepoint.com/image?relativeUrl=Lists/IAImages/Comments&site=IntraActive-Admin`}
              color={"#333333"}
              highlightColor={this.props.store.highlightColor}
              source={"SharePoint"}
              likesEnabled={false}
              commentsEnabled={true}
              newCommentPopupIsShowing={() => { }}
              isMobile={this.props.store.isMobile}
              likesUpdated={() => { }}
              commentsUpdated={() => { }}
              commentClicked={() => { }}
              commentCanceled={() => { }}
              style={{
                marginTop: 0,
                marginBottom: 0,
                transition: "opacity 200ms",
                borderRadius: 5
              }}
              padding={20}
              loadCommentsOnMount
            />
          </div>
        }
      </div>
    );
  }
}